import { HttpStatusCode } from "./HttpStatusCode";


/**
 * HttpClient result indicating something went wrong with the client itself
 */
export class ErrorResult {
    error;
    response;
    httpStatusCode;
    payload;

    get success(){
        return false;
    }

    constructor(error) {
        this.error = error;
        this.response = error?.response;
        this.httpStatusCode = error.includes("401") ? HttpStatusCode.UNAUTHORIZED : HttpStatusCode.BAD_REQUEST;
    }

    async tryReadJson() {
        try {
            if (this.response.headers.get("content-type")?.includes("application/json"))
                this.payload = await this.response.json();

            return true;
        }
        catch(e) {
            console.error(e);
            return false;    
        }
    }

    append(error) {
        this.error += `\n${error}`;
    }
    setObject(object) {
        this.response = object;
    }
}

/**
 * HttpClient all-in-one result for error or ok server results
 */
export class ServerResult {
    #response; 
    
    payload;
    httpStatusCode;
    ok; 

    get success() {
        return this.ok;
    }

    constructor(response){
        this.#response = response;
        this.ok = response.ok;
        this.httpStatusCode = response.status;
    }

    async tryReadText() {
        try {
            this.payload = await this.#response.text()
            return true;
        }
        catch(e) {
            console.error(e);
            return false;    
        }
    }


    async tryReadJson() {
        try {
            console.log(this.#response);
            if (this.#response.headers.get("content-type")?.includes("application/json"))
                this.payload = await this.#response.json()
            return true;
        }
        catch(e) {
            console.error(e);
            return false;    
        }
    }
}
